import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';
import './AuthPage.css';

export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError('');
        setBusy(true);

        try {
            const res = await api.post('/auth/login', form);

            login(res.data.token, res.data.user);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.error || 'Ошибка входа');
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className='auth-page'>
      <div className='auth-card'>
        <h1 className='auth-logo'>🏛️ GeoQuest</h1>
        <h2>Вход</h2>
        <form onSubmit={handleSubmit}>
          <input
            className='auth-input'
            type='text'
            placeholder='Имя пользователя'
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            required
          />
          <input
            className='auth-input'
            type='password'
            placeholder='Пароль'
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />
          {error && <p className='auth-error'>{error}</p>}
          <button className='auth-btn' type='submit' disabled={busy}>
            {busy ? 'Входим…' : 'Войти'}
          </button>
        </form>
        <p className='auth-link'>
          Нет аккаунта? <Link to='/register'>Зарегистрироваться</Link>
        </p>
      </div>
    </div>
    );
}
